import styled from "styled-components";

export const CmpCarInfoContent = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 24px;
  padding: 20px;
`;

export const CmpInfoHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  flex-shrink: 0;
  margin-bottom: 20px;
`;

export const CmpCarInfoConentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 21px;
`;

export const CmpInfoStep = styled.div`
  width: 100%;

  span {
    color: white;
    background-color: ${(props) => [props.theme.colors.primary]};
    padding: 6px;
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    letter-spacing: 2px;
  }

  color: ${(props) => props.theme.colors.primary};
  font-weight: 600;
  font-size: 1.7rem;
`;

export const CmpCarInfoQuest = styled.div`
  width: 100%;
  span {
    color: ${(props) => [props.theme.colors.primary]};
    font-weight: 700;
  }
  font-size: 2.4rem;
  font-weight: 500;
  word-break: break-all;
  word-wrap: break-word;
  white-space: normal;
`;

export const CmpCarInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;

  input {
    width: 100%;
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 6px;
    padding: 18px;
    outline: none;
    transition: all 0.3s;
    font-size: 1.6rem;

    &:focus {
      border: 1px solid ${(props) => props.theme.colors.primary};
    }
  }

  .vehicleNumber {
    width: 100%;
    padding: 15px;
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 4px;
    justify-content: center;
    align-items: center;
    font-size: 1.8rem;
  }
`;

export const CmpCarInfoCheckBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;

  p {
    font-size: 1.6rem;
  }
`;

export const CmpCarCheckDetail = styled.div`
  width: 100%;
  /* display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  align-items: center;
  gap: 6px;
  white-space: nowrap; */
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
`;

export const CmpButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: end;
  gap: 4px;
  flex-shrink: 0;
  margin-top: auto;
  padding: 20px 0;

  .small {
    width: 50%;
  }
`;

export const InputButton = styled.div`
  width: auto;
  display: flex;
  color: ${(props) =>
    props.color === "white"
      ? props.theme.colors.primary
      : props.color === "transparent"
      ? props.theme.colors.primary
      : props.theme.colors.white};
  background: ${(props) =>
    props.color === "transparent"
      ? "none"
      : props.color
      ? props.theme.colors[props.color]
      : props.theme.colors.primary};
  border: 1px solid ${(props) => props.theme.colors.primary};
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 1.8rem;
  font-weight: 600;
  padding: 8px;

  input {
    display: none;
  }

  &:active {
    background: ${(props) =>
      props.color === "transparent"
        ? props.theme.colors.whiteActive
        : props.color
        ? props.theme.colors[props.color + "Active"]
        : props.theme.colors.primaryActive};
  }
`;
